<template>
	<div class="course-lectures">
		<div class="lectures">
			<template v-for="(lecture, index) in courses">
				<div
					:key="index"
					class="app-card lecture lecture-card"
          @click="goToLectureVideoPage(lecture)">
					<div
            class="card-image"
            :style="{ backgroundImage: 'url(' + lecture.lecture_cover + ')' }"></div>
					<div class="card-content">
						<article>
							<h4 class="title">{{ lecture.lecture_title }}</h4>
							<p class="description" v-html="lecture.lecture_description"></p>
						</article>
					</div>
          <div class="seen" v-if="lecture.get_lecture_attempt">
            <fa-icon icon="eye" style="color: white;   text-shadow: 2px 2px #ff0000;"></fa-icon>
          </div>
				</div>
			</template>
		</div>

<!--		<div class="back-to-top">-->
<!--			<img src="../../assets/img/common/back-to-top.svg" alt="Back to top">-->
<!--		</div>-->
	</div>
</template>

<script>
  export default {
    name: 'course-lectures',

    props: {
      courses: {
        type: Array,
        default: null
      }
    },
    watch: {
      courses: val => {
        this.courses = val
      }
    },
    mounted () {
      console.log('this.courses')
      console.log(this.courses)
    },
    methods: {
      goToLectureVideoPage (lecture) {
        return this.$store.dispatch(`Course/setLecture`, lecture)
          .then(() => this.$router.push(`/lecture-video`))
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import "../../styles/styles";

	.course-lectures {
		.back-to-top {
			@extend .position-fixed;
			@extend .cursor-pointer;
			right: 20px;
			bottom: 40px;
			img {
				width: 34px;
				height: 34px;
			}
		}

    .lecture-card{
      position: relative;
    }

    svg{
      filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.6));
    }

    .seen{
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 20px;
    }
	}
</style>



// WEBPACK FOOTER //
// src/components/learning/CourseLectures.component.vue